import { useQuery } from '@tanstack/react-query'
import { clientIdentityVerificationService } from '@/services/account/identity-verification'
import { API_IDENTITY_VERIFICATION_STATUS } from '@/services/account/identity-verification/url'

const useVerificationStatusQuery = () => {
  return useQuery({
    queryKey: [API_IDENTITY_VERIFICATION_STATUS],
    queryFn: () => clientIdentityVerificationService.getVerificationStatus(),
    staleTime: 0,
    gcTime: 0,
  })
}

export default useVerificationStatusQuery
